import React from 'react';

import { Icon, PressableProps, Text } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { IconContainer, StyledPressable } from './loyalty-promo-code-cta.styled';

export const LoyaltyPromoCodeCTA = ({ onPress }: PressableProps) => {
  return (
    <StyledPressable onPress={onPress}>
      <IconContainer>
        <Icon variant="offer" color={primitive.$white} {...hiddenAccessibilityPlatformProps} />
      </IconContainer>
      <Text fontWeight="bold">{t('promoCodeCTA')}</Text>
    </StyledPressable>
  );
};
